module.exports = __webpack_public_path__ + "static/media/featured-img-default.0b863af3.jpg";